"use client";

import { useTranslations } from "next-intl";
export function PrivacyPolicy() {
  const tPrivacyPolicy = useTranslations("modules.policiesAndTerms.privacyPolicy");
  return <div className="container mx-auto px-4 py-12 sm:py-8 max-w-4xl" data-sentry-component="PrivacyPolicy" data-sentry-source-file="PrivacyPolicy.tsx">
      <h1 className="text-3xl font-bold mb-1">{tPrivacyPolicy("title")}</h1>
      <p className="text-sm text-gray-400 mb-8">
        {tPrivacyPolicy("lastUpdated")}
      </p>

      <div className="mb-8">
        <p className="mb-4">{tPrivacyPolicy("intro")}</p>
      </div>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          {tPrivacyPolicy("section1Title")}
        </h2>
        <p className="mb-4">
          {tPrivacyPolicy("section1Content")}{" "}
          <a href={`mailto:${tPrivacyPolicy("supportEmail")}`} className="text-primary underline hover:text-primary/80">
            {tPrivacyPolicy("supportEmail")}
          </a>
          .
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          {tPrivacyPolicy("section2Title")}
        </h2>
        <p className="mb-4">{tPrivacyPolicy("section2Intro")}</p>
        <ul className="list-disc ml-6 mb-4">
          <li className="mb-2">{tPrivacyPolicy("section2Item1")}</li>
          <li className="mb-2">{tPrivacyPolicy("section2Item2")}</li>
          <li className="mb-2">{tPrivacyPolicy("section2Item3")}</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          {tPrivacyPolicy("section3Title")}
        </h2>
        <p className="mb-4">{tPrivacyPolicy("section3Intro")}</p>
        <ul className="list-disc ml-6 mb-4">
          <li className="mb-2">{tPrivacyPolicy("section3Item1")}</li>
          <li className="mb-2">{tPrivacyPolicy("section3Item2")}</li>
          <li className="mb-2">{tPrivacyPolicy("section3Item3")}</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          {tPrivacyPolicy("section4Title")}
        </h2>
        <p className="mb-4">{tPrivacyPolicy("section4Content")}</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          {tPrivacyPolicy("section5Title")}
        </h2>
        <p className="mb-4">{tPrivacyPolicy("section5Content")}</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          {tPrivacyPolicy("section6Title")}
        </h2>
        <p className="mb-4">{tPrivacyPolicy("section6Content")}</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          {tPrivacyPolicy("section7Title")}
        </h2>
        <p className="mb-4">{tPrivacyPolicy("section7Intro")}</p>
        <ul className="list-disc ml-6 mb-4">
          <li className="mb-2">{tPrivacyPolicy("section7Item1")}</li>
          <li className="mb-2">{tPrivacyPolicy("section7Item2")}</li>
          <li className="mb-2">{tPrivacyPolicy("section7Item3")}</li>
        </ul>
        <p className="mb-4">
          {tPrivacyPolicy("section7Footer")}{" "}
          <a href={`mailto:${tPrivacyPolicy("supportEmail")}`} className="text-primary underline hover:text-primary/80">
            {tPrivacyPolicy("supportEmail")}
          </a>
          .
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          {tPrivacyPolicy("section8Title")}
        </h2>
        <p className="mb-4">{tPrivacyPolicy("section8Content")}</p>
      </section>
    </div>;
}